/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2019 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H133162 on 7/18/2019.
 *
 */


import React from "react";
import Progress from "../../common/Progress";
import {Icon, Table, Grid} from "@scuf/common";
import {FormattedMessage, injectIntl} from "react-intl";
import {withRouter} from "react-router";
import {fetchPredictiveIndicatorsOnAsset} from "../../api/PredictiveIndicators"
import PredictiveIndicatorDetail from "./PredictiveIndicatorDetail";
import SearchInput from "../../common/SearchInput";

class PredictiveIndicators extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            predictiveIndicators: [],
            expandedRows: [],
            filter: {
                search: '',
                criticalityLimit: 0.001,
            },
        }
        this.fetchPredictiveIndicatorsOnAsset = this.fetchPredictiveIndicatorsOnAsset.bind(this)
        this.searchChanged = this.searchChanged.bind(this)
    }

    componentDidMount() {
        this.fetchPredictiveIndicatorsOnAsset();
    }

    fetchPredictiveIndicatorsOnAsset() {
        fetchPredictiveIndicatorsOnAsset(this.props.assetId, this.state.filter.search, this.state.filter.criticalityLimit).then((predictiveIndicators) => {
            this.setState({predictiveIndicators: predictiveIndicators, loading: false})
        })
    }

    processPredictiveIndicators(predictiveIndicators) {
        if (predictiveIndicators.length === 0) {
            return null;
        }

        return predictiveIndicators.map((f,i) => {
            const rowKey = f.name + '-' + f.id;
            const thisRowExpanded = this.state.expandedRows.indexOf(rowKey) >= 0
            let expandedRow;
            if (thisRowExpanded) {
                expandedRow = (
                    <Table.Row className={this.getRowClass("expanded-row", i)}>
                        <Table.Cell colSpan={5}>
                            <PredictiveIndicatorDetail predictiveIndicator={f} assetId={this.props.assetId}/>
                        </Table.Cell>
                    </Table.Row>
                )
            }

            return (
                <React.Fragment key={rowKey}>
                    <Table.Row className={this.getRowClass("clickable-row", i)} onClick={() => this.toggleRow(rowKey)}>
                        <Table.Cell>
                            <Progress value={f.criticality*100} color={'orange'}/>
                        </Table.Cell>
                        <Table.Cell>
                            {f.name}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            <div className="expand-icon"><Icon name={thisRowExpanded ? 'caret-up' : 'caret-down'}
                                                               size="medium"/></div>
                        </Table.Cell>
                    </Table.Row>
                    {expandedRow}
                </React.Fragment>
            )
        })
    }

    getRowClass(className, index) {
        return className + ' ' + (index % 2 === 0 ? 'even' : 'odd')
    }

    toggleRow(key) {
        const rows = [...this.state.expandedRows]
        if (rows.indexOf(key) >= 0) {
            rows.splice(rows.indexOf(key), 1)
        } else {
            rows.push(key)
        }
        this.setState({expandedRows: rows})
    }

    searchChanged(search) {
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                search: search,
            },
        }, this.fetchPredictiveIndicatorsOnAsset)
    }

    render() {
        const {intl} = this.props;
        const rows = this.processPredictiveIndicators(this.state.predictiveIndicators)
        return (
            <div id="predictiveIndicators">
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={5} sWidth={12}>
                            <SearchInput placeholder={intl.formatMessage({id: "filter.search"})} fluid onChange={this.searchChanged}/>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                {this.state.predictiveIndicators.length === 0 ?
                    <FormattedMessage id="faults.tab.predictiveIndicators.empty"/>
                    :
                    <Table className="predictive-indicator-table unstackable">
                        <Table.Header>
                            <Table.HeaderCell className="progress-cell"
                                              content={intl.formatMessage({id: "faults.tab.predictiveIndicators.criticality"})}/>
                            <Table.HeaderCell className="wide-cell"
                                content={intl.formatMessage({id: "faults.tab.predictiveIndicators.name"})}/>
                            <Table.HeaderCell className="icon-cell"/>
                        </Table.Header>
                        <Table.Body>
                            {rows}
                        </Table.Body>
                    </Table>
                }
            </div>
        )
    }
}

export default injectIntl(withRouter(PredictiveIndicators))

